// extracted by mini-css-extract-plugin
export default {"trigger":"MobileDateField_trigger__5fi39","icon":"MobileDateField_icon__36z2y","text":"MobileDateField_text__-jNzT","portalHost":"MobileDateField_portalHost__PsH7I"};